import {
  compareMarketShareByViewTips,
  compareKeyMetricsViewsTips,
  compareKeyMetricsImpressionsTips,
  compareKeyMetricsEngagementTips,
  compareKeyMetricsPublicationsTips,
} from '@op/components/BubbleCommon';
import { arrayToSimpleObj } from '@op/utils';

export const tableColumnsList = [
  { text: 'View', value: 'views', tips: compareKeyMetricsViewsTips },
  {
    text: 'Market Share by View',
    value: 'market_share_by_view',
    width: 240,
    isPercentage: true,
    tips: compareMarketShareByViewTips,
  },
  {
    text: 'Potential Impressions',
    value: 'impressions',
    width: 240,
    tips: compareKeyMetricsImpressionsTips,
  },
  {
    text: 'Engagement',
    value: 'engagement',
    tips: compareKeyMetricsEngagementTips,
  },
  {
    text: 'Publication',
    value: 'publications',
    tips: compareKeyMetricsPublicationsTips,
  },
];

export const tableColumnsMap = arrayToSimpleObj(
  tableColumnsList,
  'text',
  'value',
);
